













import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { readStepByStepGuidesFromLocalStorage } from '@/utils/localStorage';
import { TOURS } from '@/constants/tour';

@Component({
  computed: {
    ...mapState({
      loading: 'loading',
    }),
    ...mapState('Tour', {
      name: 'name',
      steps: 'steps',
    }),
  },
})
export default class QStripeServicePaymentDialog extends Vue {
  name!: string;
  tours = TOURS;

  handleCallbacks = {
    onSkip: this.storeTourInLocalStorage,
    onFinish: this.storeTourInLocalStorage,
  };

  // use local storage to manage the flag
  storeTourInLocalStorage() {
    const guides = readStepByStepGuidesFromLocalStorage();
    if (!guides.includes(this.name)) {
      const newGuides = [...guides, this.name];
      localStorage.setItem('step_by_step_guides', JSON.stringify(newGuides));
    }
  }
}
